import React from 'react';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import serialize from 'serialize-javascript';
import MobileApi from 'lib/MobileApi';
import Script from 'next/script';
import { useSearchParams } from 'next/navigation';

function AnalyticsLaunchScripts(props) {
  const searchParams = useSearchParams();
  const { isChromeless = false, pageID = '' } = props;
  const {
    publicRuntimeConfig: {
      dev,
    },
  } = getConfig();

  const envKey = searchParams?.get('adobeLaunchEnv') ?? (dev ? 'Staging' : 'Production');

  const standardWebEnvs = {
    Dev_1: '//assets.adobedtm.com/launch-EN2e599cbd777a4ccfbbeced35f4cb44ce-development.min.js',
    Dev_2: '//assets.adobedtm.com/launch-EN333a0d1b6e5f4ec78664fb6291f53814-development.min.js',
    Dev_3: '//assets.adobedtm.com/a2ef59fba8e9/0c702136bee3/launch-4d8583682bc8-development.min.js',
    Dev_4: '//assets.adobedtm.com/a2ef59fba8e9/0c702136bee3/launch-938016caa262-development.min.js',
    Dev_5: '//assets.adobedtm.com/a2ef59fba8e9/0c702136bee3/launch-12c0ac7b9b78-development.min.js',
    TelemundoTest: '//assets.adobedtm.com/launch-EN6027f91084de4c6283d895babece1603-development.min.js',
    TagTesting: '//assets.adobedtm.com/a2ef59fba8e9/0c702136bee3/launch-3ee417934b8e-development.min.js',
    Staging: '//assets.adobedtm.com/launch-EN73ef4bfbb64046d89ea9b8f64998688c-staging.min.js',
    Production: '//assets.adobedtm.com/launch-EN03682f66064449c8b87d78eae3e2fc57.min.js',
  };

  const mobileWebviewEnvs = {
    Staging: '//assets.adobedtm.com/a2ef59fba8e9/cc4d79a84dbc/launch-486f773164c9-staging.min.js',
    Production: '//assets.adobedtm.com/a2ef59fba8e9/cc4d79a84dbc/launch-090c00ff8651.min.js',
  };

  const envs = isChromeless ? mobileWebviewEnvs : standardWebEnvs;
  const launchSrc = envs[envKey] ?? envs.Production;

  if (isChromeless && pageID) {
    const js = `window.__MobileApi = ${serialize(
      MobileApi,
    )}; __MobileApi.trackPageView('${pageID}');`;
    return (
      <Script
        id="mobile-api-launch"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{ __html: js }}
      />
    );
  }

  return (
    <Script
      id="adobe-launch"
      src={launchSrc}
      strategy="beforeInteractive"
    />
  );
}

AnalyticsLaunchScripts.propTypes = {
  isChromeless: PropTypes.bool,
  pageID: PropTypes.string,
};

export { AnalyticsLaunchScripts };
